export type Highlight = {
  id: string;
  title: string;
};
